<div class="dropdown">
  <button
    class="btn text-muted dropdown-toggle d-flex align-items-center"
    type="button"
    data-bs-toggle="dropdown"
    id="dropdown-button"
    data-display="static"
    aria-haspopup="true"
    aria-expanded="false">
    <div>{{ filterBy() }}</div>
  </button>
  <div class="dropdown-menu" onClick="event.stopPropagation()" aria-labelledby="dropdown-button">
    <div class="dropdown-header ps-2 pb-0">
      <div class="row">
        <div class="col-5"></div>
        <div class="col-7">
          <p class="text-decoration-underline" role="button" (click)="clearAll()">Tout effacer</p>
        </div>
      </div>
    </div>
    @for (filtre of filters; track filtre; let index = $index) {
    <div class="ps-2">
      <div class="form-check">
        <input
          class="form-check-input cursor-pointer"
          type="checkbox"
          [id]="index"
          [(ngModel)]="filtre.selected"
          (ngModelChange)="changeSelection()" />
        <label class="form-check-label ms-2" [for]="index">
          {{ filterBy() === "Statut" ? getStatusTitle(filtre.value) : filtre.value.name }}
          @if (displayingCertifyingAssessmentIcon(filtre.value)) {
          <syn-certified-assessment-icon />
          }
        </label>
      </div>
    </div>
    }
  </div>
</div>
